/**
 * Sort options for the Add Player to List modal dropdown
 *
 * Defines available sort fields and their display labels.
 * @module features/scouting/constants/sortOptions
 */

import { OrderByDirection, SortField } from "@/generated/graphql";

import type { SortOption } from "../types/scouting-target";

/** Default sort field when no explicit selection is made */
export const DEFAULT_SORT_FIELD = SortField.Gpr;

/** Default sort direction when no explicit selection is made */
export const DEFAULT_SORT_ORDER = OrderByDirection.Desc;

/** Available sort options for the player search modal */
export const SORT_OPTIONS: readonly SortOption[] = [
  { field: "GPR", label: "GPR" },
  { field: "FIT_SCORE", label: "Player Style Fit" },
  { field: "TEAM_STYLE_FIT", label: "Team Style Fit" },
  { field: "CARRYING", label: "Carrying" },
  { field: "DRIBBLING", label: "Dribbling" },
  { field: "PASSING", label: "Passing" },
  { field: "SHOOTING", label: "Shooting" },
  { field: "GK_PASSING", label: "GK Passing" },
  { field: "GK_POSITIONING", label: "GK Positioning" },
  { field: "GK_SHOT_STOPPING", label: "GK Shot Stopping" },
  { field: "MONTHS_REMAINING", label: "Months Remaining" },
  { field: "PLAYER_VALUATION", label: "Transfer Value" },
] as const;

/** Maps SortField enum values to short labels for the metric tag in search results */
export const SORT_FIELD_LABELS: Record<string, string> = {
  GPR: "GPR",
  FIT_SCORE: "Style Fit",
  TEAM_STYLE_FIT: "Team Fit",
  CARRYING: "Carrying",
  DRIBBLING: "Dribbling",
  PASSING: "Passing",
  SHOOTING: "Shooting",
  GK_PASSING: "GK Pass",
  GK_POSITIONING: "GK Pos",
  GK_SHOT_STOPPING: "GK Shot",
  MONTHS_REMAINING: "Months",
  PLAYER_VALUATION: "Value",
} as const;
